let modalSets = document.querySelectorAll('.modal--wrapper');

modalSets.forEach((modalSet, index) =>{
  var modal = modalSet.querySelector(".modal");
  var modalOverlay = modalSet.querySelector(".modal__overlay");
  var closeButton = modalSet.querySelector(".modal__close-button");
  var openButton = modalSet.querySelector(".modal__open-button");
  if (modal) {
    Array.prototype.slice.call([closeButton, modalOverlay, openButton]).forEach(function (el) {
      if (el) {
        el.addEventListener("click", function () {
          toggleModal();
        });
      }
    })
  }

  function toggleModal() {
    modal.classList.toggle("hidden");
    modalOverlay.classList.toggle("hidden");
  }
})
